<template>
  <div class="post-class-box">
   <ul class="show-flex-box-r">
     <li v-for= "(item,index) in postClassList" :key= "index">
       <strong :class= "{'class-selected': selectedIndex == index}" @click= "choosePostClass(item,index)">{{item.name}}</strong>
     </li>
   </ul>
  </div>
</template>

<script>
/*
 * 组件提供的数据：选中的类别对象： @choosePostClass
 * 
 * 所需参数
 * :forumKinds-'forum':普通论坛; 'teacherForum': 机构论坛
 * 
 */

export default {
  name: 'post_class_cpn',
  props:{
    'forumKinds': [String,Object]
  },
  data () {
    return {
      postClassList: [],
      selectedIndex: -1
    }
  },
  mounted() {
    this.getForumSortnav();
  },
  methods: {
    choosePostClass: function(classObj,index) {
      this.selectedIndex = index;
      this.$emit("choosePostClass",classObj);
    },
    //获取论坛板块列表
    getForumSortnav: function() {
      let forumType = this.forumKinds;
      let vSelf = this;

      if (forumType == 'forum') {
        this.$client.getForumSortnav()
        .then((res) => {
          vSelf.postClassList = res.data.list;
        }).catch((err) => {

        })
      } else if (forumType == 'teacherForum') {
        this.$client.getTeacherForumSortnav()
        .then((res) => {
          this.postClassList = res.data.list;
        }).catch((err) => {

        })
      }
    }
  },
  watch:{
    forumKinds: function() {
      this.getForumSortnav();
    }
  }
}
</script>

<style lang="less" scoped>
  .post-class-box {
    overflow: hidden;
    &>ul {
      overflow-y: scroll;
      flex-wrap: wrap;
      height: 128px;
      margin-right: -20px;
      &>li {
        flex-shrink: 0;
        margin-right: 20px;
        margin-bottom: 20px;
        &>strong {
          display: block;
          height: 42px;
          padding-left: 30px;
          padding-right: 30px;
          text-align: center;
          line-height: 42px;
          border-radius: 21px;
          border: 1px solid #dedede;
          cursor: pointer;
          color: #555;
        }
        &>strong.class-selected {
          border: 1px solid #ff7800;
          background: #fff9f1;
          color: #ff7800;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/post_message/post_class_cpn.vue